import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation(["pages"]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center px-6">
        <div className="text-9xl font-bold text-emerald-700 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          404
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-4">
          {t("pages:notFound.title")}
        </h1>
        <p className="text-slate-500 mb-8 max-w-md mx-auto">
          {t("pages:notFound.description")}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-8 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line" />
          {t("pages:notFound.button")}
        </Link>
      </div>
    </div>
  );
}